import React from 'react'
import { inject, observer } from 'mobx-react'
import { Button, DatePicker, Input, Modal } from 'antd'
import users from '@services/users'
import { alertPopup } from '@utils/popup'
import moment from 'moment'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
class AddPaymentLate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            date: '',
            open_comment: '',
            requiredMsg: false
        }
    }

    openModal = () => {
        const {
            popupStore: { togglePopup }
        } = this.props
        togglePopup('openPaymentLatePopup')
    }

    onClose = () => {
        const {
            popupStore: { togglePopup }
        } = this.props
        togglePopup(false)
    }

    reset = () => {
        this.setState({ date: '', open_comment: '', requiredMsg: false })
    }

    submit = () => {
        const {
            clientInfo: { user_subscription_id },
            getClientInfo
        } = this.props
        const { date, open_comment } = this.state

        const payload = {
            user_subscription_id,
            payment_late_since: date || new Date(),
            open_comment
        }

        if (!open_comment) {
            this.setState({ requiredMsg: true })
        } else {
            this.setState({ requiredMsg: false })
            users
                .addPaymentLate(payload)
                .then(() => {
                    getClientInfo()
                    this.reset()
                    alertPopup({ type: 'success', title: 'עודכן בהצלחה', body: '' })
                })
                .catch(() => {
                    alertPopup({ type: 'error', title: 'עדכון נכשל', body: '' })
                })
        }
    }

    render() {
        return (
            <div>
                <Button onClick={() => this.openModal()}>פתיחת איחור בתשלום</Button>
                <Modal
                    onCancel={this.onClose}
                    visible={this.props.popupStore.popupType === 'openPaymentLatePopup'}
                    title={`פתיחת איחור בתשלום`}
                    footer={null}
                >
                    <div style={{ ...style.modalContent }}>
                        <div style={{ ...style.row }}>
                            <span>{'תאריך:'}</span>
                            <DatePicker
                                format={'DD/MM/YYYY'}
                                defaultValue={moment(new Date(), 'DD/MM/YYYY')}
                                onChange={e =>
                                    this.setState({
                                        date: e ? e.format('YYYY-MM-DD 00:00:00') : '',
                                        requiredMsg: false
                                    })
                                }
                                disabledDate={current => moment() <= current}
                                style={{ border: 'none', width: '80%' }}
                            />
                        </div>
                        <div style={{ ...style.row }}>
                            <span>{'פירוט:'}</span>
                            <Input.TextArea
                                style={{ width: '80%' }}
                                value={this.state.open_comment}
                                onChange={e => this.setState({ open_comment: e.target.value, requiredMsg: false })}
                            />
                        </div>
                        <Button
                            onClick={this.submit}
                            style={{
                                alignSelf: 'center',
                                marginLeft: 0
                            }}
                        >
                            {'אישור'}
                        </Button>
                        {this.state.requiredMsg && (
                            <h6
                                style={{
                                    color: 'blue',
                                    alignSelf: 'center',
                                    marginTop: '10px'
                                }}
                            >
                                {'יש להזין תאריך ופירוט'}
                            </h6>
                        )}
                    </div>
                </Modal>
            </div>
        )
    }
}

const style = {
    modalContent: { display: 'flex', flexDirection: 'column' },
    row: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }
}

export default AddPaymentLate
